import {setLoginToken} from '@/utils/auth'

const user = {
  state: {
    token: '', // 登录后的token
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      setLoginToken(token)
    },
  },

  actions: {
  }
}

export default user
